import { Col, Row, Card, Select, Upload } from "antd";
import React, { useState } from "react";
import { AsumsiIcon, Modal, FormItem, Form, Input } from "asumsi-components";
import { IResponsePost } from "@interfaces/iresponse-post";
import moment from "moment";
import ImgCrop from 'antd-img-crop';
import Truncate from "react-truncate";

const { Option } = Select;
export const HeroRight = (props: any) => {
    const { setFieldsValues, fieldsValues, posts, videos, uploadBanner, getBase64, onPreview, beforeUpload, findDataPost, findDataVideo } = props;
    const [showHeroRightForm, setShowHeroRightForm] = useState(false);
    const [fileList, setFileList] = useState([]);
    const initialFieldsRightValues: any = {
        type: "post",
        page: null,
        orderNumber: 1,
        url: null,
        image: null,
        imageUrl: null
    };
    const [fieldsHeroRightValues, setFieldsHeroRightValues]: any = useState(initialFieldsRightValues);
    const onclickRemoveHeroRight = (orderNumber: number) => {
        const heroRightExisting: any[] = fieldsValues.heroRight ?? [];
        const newHeroRight: any[] = heroRightExisting.filter((sec: any) => sec.orderNumber !== orderNumber);
        setFieldsValues({ ...fieldsValues, heroRight: newHeroRight });
    }

    const emptyImage = (type?: string, description?: string, orderNumber?: number) =>
        <div className={`empty-upload ${type ?? ""}`}
            onClick={() => {
                setFieldsHeroRightValues({ page: null, type: "post", orderNumber: orderNumber ?? 1, image: null })
                setShowHeroRightForm(true);
            }}
        >
            <Row justify="space-around" align="middle" style={{ height: "100%" }}>
                <Col style={{ height: "100%" }}>
                    <p className="desc">{description ?? "set as post or banner"}</p>
                </Col>
            </Row>
        </div>;

    const defaultHeroRight = (data: any, orderNumber: number) => {
        let view: any = null;
        if (data.type == "post" || data.type == "video") {
            view = <div className="hero-right-card display-flex">
                <div className="badges">
                    <div className="badges-post">
                        {data.type.toUpperCase()}
                    </div>
                </div>
                <div className={`post ${data.imageUrl ? 'mid' : ''}`}>
                    <div className="display-flex">
                        <div className="topic-post">{data.topic && data.topic.name ? data.topic.name : "General"}</div>
                        <div className="post-date">{moment(data.publishDateTime).format("DD MMM yyyy HH:mm")}</div>
                    </div>
                    <div className="post-title">
                        <Truncate lines={3} ellipsis=" ..." trimWhitespace={true}>
                            {data.title}
                        </Truncate>
                    </div>
                </div>
                <img src={data.imageUrl}></img>
                <div className="card-actions">
                    <div className="actions picture">
                        <AsumsiIcon icon="trash" onClick={() => onclickRemoveHeroRight(orderNumber)} />
                    </div>
                </div>
            </div >;
        } else if (data.type == "banner") {
            view = <div className="hero-right-card banner display-flex">
                <div className="badges">
                    <div className="badges-post">
                        {data.type.toUpperCase()}
                    </div>
                </div>
                <img src={data.imageUrl}></img>
                <div className="card-actions">
                    <div className="actions picture">
                        <AsumsiIcon icon="trash" onClick={() => onclickRemoveHeroRight(orderNumber)} />
                    </div>
                </div>
            </div>;
        } else {
            view = emptyImage("hero-right", "set as post or banner", orderNumber);
        }
        return view;
    }

    const onChangeHeroRight = (value: any) => {
        if (!value) {
            fieldsHeroRightValues.type == "video" ? findDataVideo() : findDataPost();
        }
        setFieldsHeroRightValues({ ...fieldsHeroRightValues, page: value, errors: [] })
    }

    const onSaveHeroRight = async () => {
        const heroRight: any = fieldsValues.heroRight ?? [];
        const index: number = fieldsHeroRightValues.orderNumber ?? 1;
        const finIndex = heroRight.findIndex((sec: any) => sec.orderNumber == index);

        if (fieldsHeroRightValues.type == "banner") {
            const uploadImage: any = await uploadBanner({
                image: fieldsHeroRightValues.image,
                imageCreditBy: "",
                size: "small",
                type: "banner",
                url: fieldsHeroRightValues.url,
            });

            const objectKey: any = {
                type: fieldsHeroRightValues.type,
                id: uploadImage.id,
                orderNumber: index,
                imageUrl: uploadImage.imageUrl,
                title: null,
                excerpt: null,
                topic: null,
                publishDateTime: null
            }
            if (finIndex >= 0) {
                heroRight[finIndex] = objectKey;
            } else {
                heroRight.push(objectKey);
            }
        } else {
            const objectData = JSON.parse(fieldsHeroRightValues.page ?? "");
            if (finIndex >= 0) {
                heroRight[finIndex] = objectData;
            } else {
                heroRight.push(objectData);
            }
        }

        setFieldsValues({ ...fieldsValues, heroRight });
        setShowHeroRightForm(false);
    }

    const optionHeroRight = () => {
        let option: any = posts ? posts.map((post: IResponsePost) => {
            const objectKey: any = {
                type: "post",
                id: post.id,
                pid: post.pid,
                orderNumber: fieldsHeroRightValues.orderNumber,
                imageUrl: post.imageUrl,
                title: post.title,
                excerpt: post.excerpt,
                topic: post.topic,
                publishDateTime: post.publishDateTime
            }
            return <Option key={JSON.stringify(objectKey)} value={JSON.stringify(objectKey)}>{post.title}</Option>
        }) : null;

        if (fieldsHeroRightValues.type === "video") {
            option = videos ? videos.map((video: any) => {
                const objectKey: any = {
                    type: fieldsHeroRightValues.type,
                    id: video.id,
                    url: video.url,
                    orderNumber: fieldsHeroRightValues.orderNumber,
                    imageUrl: video.thumbnails.medium.url,
                    title: video.title,
                    excerpt: video.description,
                    topic: { name: 'Video' },
                    publishDateTime: video.publishedAt
                }
                return <Option key={JSON.stringify(objectKey)} value={JSON.stringify(objectKey)}>{video.title}</Option>
            }) : null;
        }

        return option;
    }

    const onChangeHeroRightType = (value: any) => {
        setFieldsHeroRightValues({ orderNumber: fieldsHeroRightValues.orderNumber, page: null, type: value });
        setFileList([]);
    }

    const onChangeImageInput = async ({ fileList: newFileList }: any) => {
        if (newFileList[0]) {
            const tumbnail = await getBase64(newFileList[0].originFileObj);
            newFileList[0].thumbUrl = tumbnail;
            newFileList[0].status = 'done';
        }
        const errors: string[] = [];
        if (newFileList[0]) {
            errors.push('image');
        }

        if (!fieldsHeroRightValues.url) {
            errors.push('url');
        }

        setFieldsHeroRightValues({ ...fieldsHeroRightValues, imageUrl: newFileList[0].thumbUrl, image: newFileList[0] ? newFileList[0].originFileObj : null, errors })
        setFileList(newFileList);
    };

    const defaultImage = (imageUrl: string) => {
        const onDeleteImage = () => {
            const errors: string[] = ['image'];
            if (!fieldsHeroRightValues.url) {
                errors.push('url');
            }
            setFieldsHeroRightValues({ ...fieldsHeroRightValues, image: null, imageUrl: null, errors });
            setFileList([]);
        }
        return <div className="upload-list-item-info">
            <img src={imageUrl} className="upload-list-item-image"></img>
            <div className="card-actions">
                <div className="actions picture">
                    <AsumsiIcon icon="trash" onClick={onDeleteImage} />
                </div>
            </div>
        </div>
    }

    const emptyImageInput = () => <div className="empty-upload image-input">
        <Row justify="space-around" align="middle" style={{ height: "100%" }}>
            <Col style={{ height: "100%" }}>
                <p className="size">640x160</p>
                <p className="desc">Click to browse or drag file to this area to upload</p>
            </Col>
        </Row>
    </div>;


    return <Col span={10} style={{ paddingLeft: "36px" }}>
        <Row>
            <Col span={24}>
                {fieldsValues.heroRight && fieldsValues.heroRight.length > 0 && fieldsValues.heroRight.filter((ft: any) => ft.orderNumber == 1).length > 0 ? defaultHeroRight(fieldsValues.heroRight.filter((ft: any) => ft.orderNumber == 1)[0], 1) : emptyImage("hero-right", "set as post or banner", 1)}
            </Col>
            <Col span={24}>
                {fieldsValues.heroRight && fieldsValues.heroRight.length > 0 && fieldsValues.heroRight.filter((ft: any) => ft.orderNumber == 2).length > 0 ? defaultHeroRight(fieldsValues.heroRight.filter((ft: any) => ft.orderNumber == 2)[0], 2) : emptyImage("hero-right", "set as post or banner", 2)}
            </Col>
            <Col span={24}>
                {fieldsValues.heroRight && fieldsValues.heroRight.length > 0 && fieldsValues.heroRight.filter((ft: any) => ft.orderNumber == 3).length > 0 ? defaultHeroRight(fieldsValues.heroRight.filter((ft: any) => ft.orderNumber == 3)[0], 3) : emptyImage("hero-right", "set as post or banner", 3)}
            </Col>
            <Col span={24}>
                {fieldsValues.heroRight && fieldsValues.heroRight.length > 0 && fieldsValues.heroRight.filter((ft: any) => ft.orderNumber == 4).length > 0 ? defaultHeroRight(fieldsValues.heroRight.filter((ft: any) => ft.orderNumber == 4)[0], 4) : emptyImage("hero-right", "set as post or banner", 4)}
            </Col>
        </Row>
        <Modal
            key="hero-right-form"
            show={showHeroRightForm}
            setShow={setShowHeroRightForm}
            title='Set hero section right'
            okText="Save"
            actionBottom={true}
            onOk={onSaveHeroRight}
            className="modal-right-hero"
            onCancel={() => setFieldsHeroRightValues({ page: null, type: "post", orderNumber: 1 })}
            disableButtonOk={fieldsHeroRightValues.errors && fieldsHeroRightValues.errors.length > 0}
        >
            <Card>
                <Form titleBold={true}>
                    <Row gutter={30}>
                        <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                            <FormItem label="Content to display" setFieldsValues={setFieldsHeroRightValues} fieldsValues={fieldsHeroRightValues}>
                                <Select style={{ width: "100%" }} defaultValue={fieldsHeroRightValues.type} value={fieldsHeroRightValues.type} onChange={onChangeHeroRightType}>
                                    <Option key="post" value="post">Post</Option>
                                    <Option key="banner" value="banner">Banner</Option>
                                    <Option key="video" value="video">Video</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                            <FormItem className={fieldsHeroRightValues.type != "banner" ? "" : "hidden"} label="Selected Post" setFieldsValues={setFieldsHeroRightValues} fieldsValues={fieldsHeroRightValues} fieldDecorator={{
                                label: "page",
                                rules: [{
                                    message: 'Please select post',
                                    required: fieldsHeroRightValues.type != "banner" ? true : false,
                                }
                                ]
                            }}>
                                <Select
                                    style={{ width: "100%" }}
                                    allowClear
                                    onSearch={(value: string) =>fieldsHeroRightValues.type == "video" ? findDataVideo(value) : findDataPost(value)}
                                    showSearch
                                    optionFilterProp="children"
                                    defaultValue={fieldsHeroRightValues.page}
                                    value={fieldsHeroRightValues.page}
                                    onChange={onChangeHeroRight}>
                                    {optionHeroRight()}
                                </Select>
                            </FormItem>
                            <FormItem className={fieldsHeroRightValues.type == "banner" ? "" : "hidden"} setFieldsValues={setFieldsHeroRightValues} label="Image" fieldsValues={fieldsHeroRightValues} labelAlign="left"
                                fieldDecorator={{
                                    label: "image",
                                    rules: [{
                                        message: 'Please upload banner image',
                                        required: fieldsHeroRightValues.type == "banner" ? true : false,
                                    }
                                    ]
                                }}
                            >
                                {fieldsHeroRightValues.imageUrl ? defaultImage(fieldsHeroRightValues.imageUrl) :
                                // hero right banner
                                    <ImgCrop aspect={4} rotate>
                                        <Upload
                                            listType="picture"
                                            fileList={fileList}
                                            openFileDialogOnClick={true}
                                            onChange={onChangeImageInput}
                                            onPreview={onPreview}
                                            beforeUpload={beforeUpload}
                                        >
                                            {fileList.length == 0 && emptyImageInput()}
                                        </Upload>
                                    </ImgCrop>}

                            </FormItem>
                            <FormItem hint="Please include http:// or https:// for outer link" className={fieldsHeroRightValues.type == "banner" ? "" : "hidden"} setFieldsValues={setFieldsHeroRightValues} label="Link" fieldsValues={fieldsHeroRightValues} labelAlign="left"
                                fieldDecorator={{
                                    label: "url",
                                    rules: [{
                                        message: 'Please input banner url',
                                        required: fieldsHeroRightValues.type == "banner" ? true : false,
                                    }
                                    ]
                                }}
                            >
                                <Input id="url" key="url" defaultValue={fieldsHeroRightValues.url} />
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </Modal>
    </Col>;
}

export default HeroRight;


// WEBPACK FOOTER //
// ./src/pages/homepage-form/libraries/heroRight.tsx